import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import PriceSimulatorDialog from './PriceSimulatorDialog';
import { useTranslation } from '../../app/LanguageContext';

export default function PriceSimulatorTriggerButton({ description, quantity, onSetPrice }) {
  const { translate } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={translate('extensions.price_simulator.trigger_tooltip')}>
        <IconButton
          size="small"
          edge="end"
          color="primary"
          onClick={() => setOpen(true)}
          aria-label={translate('extensions.price_simulator.trigger_tooltip')}
          sx={{ p: 0.5, flexShrink: 0 }}
        >
          <CalculateOutlinedIcon sx={{ fontSize: '1.15rem' }} />
        </IconButton>
      </Tooltip>

      <PriceSimulatorDialog
        open={open}
        onClose={() => setOpen(false)}
        initialDescription={description ?? ''}
        initialQuantity={quantity ?? 1}
        onApplyPrice={onSetPrice}
      />
    </>
  );
}
